import defaultState from './state'
import {
  SET_PRODUCT_LANGUAGE,
  SET_PRODUCT_FORMATS,
  SET_RELATED_PRODUCT_FORMAT_IN_CART
} from './actions'

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_PRODUCT_LANGUAGE:
      return {
        ...state,
        productLanguage: action.productLanguage
      }

    case SET_PRODUCT_FORMATS:
      return {
        ...state,
        productFormats: action.productFormats
      }

    case SET_RELATED_PRODUCT_FORMAT_IN_CART:
      return {
        ...state,
        relatedProductFormatInCart: action.relatedProductFormatInCart
      }

    default:
      return state
  }
}
